// =========================================================
// * Vue Material Kit - v1.2.2
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-kit
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-kit/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto-slab/400.css";
import "@fontsource/roboto-slab/700.css";
import "@fontsource/material-icons/400.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@mdi/font/css/materialdesignicons.min.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import MaterialKit from "./plugins/material-kit";
import vuetify from "./plugins/vuetify";

import { Auth0Plugin } from "./auth";

// Datatable
import { VuejsDatatableFactory } from "vuejs-datatable";

// Apexcharts
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchartComponent", VueApexCharts);

Vue.use(VuejsDatatableFactory);
Vue.use(MaterialKit);

Vue.config.productionTip = false;

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    const target =
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname;
    // Auth0 can return to the route already opened by Vue Router.
    if (
      router.currentRoute.fullPath !== router.resolve(target).route.fullPath
    ) {
      router.push(target);
    }
  },
});

const NavbarStore = {
  showNavbar: false,
};

Vue.material.locale.dateFormat = "dd.MM.yyyy";

Vue.mixin({
  data() {
    return {
      NavbarStore,
    };
  },
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
